import { makeStyles, Theme } from '@material-ui/core';

export const useListContainerStyles = makeStyles((theme: Theme) => ({
    container: {
        width: '100%',
        height: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
    },
    compact: {
        '& .cell': {
            padding: theme.spacing(1),
        },
    },
}));

export const useListStyles = makeStyles((theme: Theme) => ({
    list: {
        minWidth: 'fit-content',
        height: '100%',
        margin: 0,
        padding: 0,
        listStyle: 'none',
        overflowX: 'hidden',
    },
}));

export const useListItemStyles = makeStyles((theme: Theme) => ({
    item: {
        display: 'flex',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, .05)',
        },
    },
    selected: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette.primary.main,
    },
}));

export const useListHeaderStyles = makeStyles((theme: Theme) => ({
    header: {
        display: 'flex',
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        fontWeight: 'bold',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        width: 'fit-content',
        minWidth: '100%',
        whiteSpace: 'nowrap',
    },
}));

export const useListCellStyles = makeStyles((theme: Theme) => ({
    cell: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2),
        fontSize: theme.typography.body1.fontSize,
    },
}));
